export default "__VITE_ASSET__BQMsXlFj__"